import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledTextWrapper: any = styled.div`
  color: '#000';
  padding: 0 10px 10px 0;
  align-self: left;
  width: 100%;
`;

export const StyledImagePlaceholder: any = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledImageWrapper: any = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  > img:nth-child(2) {
    transform: scale(1.15);
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    > img:nth-child(2) {
      margin-top: -80px;
    }
  }
`;

export const StyledImageGroup: any = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
`;
export const ModelCardContainer: any = styled.div`
  display: flex;
  flex-flow: wrap;
`;

export const OverallRatingTextWrapper: any = styled.div`
  width: 100%;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FiveStarsWrapper: any = styled.div`
  width: 100%;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  border-bottom: 1px solid #dfe4e8;
  margin-bottom: 30px;
  @media (min-width: ${Breakpoints.b960}px) {
    padding-bottom: 0;
    border-bottom: unset;
    margin-bottom: 0;
  }
`;

export const FiveStarsTextWrapper: any = styled.div`
  padding-left: 5px;
  color: #6a767d;
`;
export const FiveStarsDisclaimerWrapper: any = styled.div`
  padding-top: 20px;
  color: #6a767d;
`;

export const StyledReviewsLabelWrapper: any = styled.div`
  padding-top: 10px;
  @media (min-width: ${Breakpoints.b960}px) {
    padding-top: 40px;
  }
`;
